export default "__VITE_ASSET__1c66d3d9__"